import _extends from 'babel-runtime/helpers/extends';
import _objectWithoutProperties from 'babel-runtime/helpers/objectWithoutProperties';
import _classCallCheck from 'babel-runtime/helpers/classCallCheck';
import _createClass from 'babel-runtime/helpers/createClass';
import _possibleConstructorReturn from 'babel-runtime/helpers/possibleConstructorReturn';
import _inherits from 'babel-runtime/helpers/inherits';
import React, { PureComponent } from 'react';
import { DraftEditor } from '../../..';
import { utils, translations } from 'gipsy-misc';
import { task as taskApi } from 'gipsy-api';

import Field from '../../components/Field';
import get from 'lodash/get';

var Description = function (_PureComponent) {
  _inherits(Description, _PureComponent);

  function Description() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Description);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Description.__proto__ || Object.getPrototypeOf(Description)).call.apply(_ref, [this].concat(args))), _this), _this.onFocus = function (e) {
      _this.props.openField(e, _this.props.id);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Description, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          id = _props.id,
          mode = _props.mode,
          isActive = _props.isActive,
          isOpen = _props.isOpen,
          onChange = _props.onChange,
          value = _props.value,
          loading = _props.loading,
          placeholderPath = _props.placeholderPath,
          onImageUpload = _props.onImageUpload,
          uploads = _props.uploads,
          rest = _objectWithoutProperties(_props, ['id', 'mode', 'isActive', 'isOpen', 'onChange', 'value', 'loading', 'placeholderPath', 'onImageUpload', 'uploads']);

      return React.createElement(
        Field,
        { className: 'description-field' + (isActive ? ' active' : '') + (isOpen ? ' open' : '') },
        React.createElement(
          'div',
          { className: 'row', onClick: utils.DOM.stopPropagation },
          !loading ? React.createElement(
            'div',
            null,
            React.createElement(DraftEditor, _extends({
              placeholder: get(translations, placeholderPath),
              paramName: id,
              onChange: onChange,
              onFocus: this.onFocus,
              defaultValue: value,
              compact: !isOpen,
              padding: true,
              transparent: true,
              backgroundHover: true,
              onImageUpload: onImageUpload,
              uploads: uploads,
              getUploadUrls: taskApi.uploads.images.request
            }, rest))
          ) : React.createElement(
            'div',
            { className: 'placeholder' },
            get(translations, placeholderPath)
          )
        )
      );
    }
  }]);

  return Description;
}(PureComponent);

/* used by tests : enzyme selector */


Description.displayName = 'DescriptionField';

export default Description;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ../gipsy-ui/lib/TaskPanel/fields/Description/index.js
// module id = 499
// module chunks = 0